<template>
  <div>
    <h3 class="text-dark text-2xl font-semibold mb-3">{{ title }}</h3>
    <div class="table table-fixed rounded">
      <div v-for="(row, index) in brandsTable" :key="index" class="table-row rounded">
        <nuxt-link v-for="brand in row" :key="brand.id"
          class="table-cell align-middle text-center border border-[#D4D7DE] rounded min-w-[130px] brand"
          :to="({ path: '/cruise-map', query: { company_id: [brand.id] } })" target="_blank" :title="brand.title">
          <div class="flex h-[68px] items-center mx-[16px] py-[16px] brand-item">
            <el-image class="h-[36px] w-[104px] mr-[12px] border border-[#1F2129] rounded" fit="cover" lazy
              :src="brand.image" />
            <h3 class="text-base text-[#1F2128]">{{ brand.name }}</h3>
          </div>
        </nuxt-link>
      </div>
    </div>
  </div>
</template>
<script>
import { computed } from "@nuxtjs/composition-api";
import { chunk } from "~/utils/helpers";
export default {
  name: "AffiliatedBrandTable",
  props: {
    title: {
      type: String,
      default: "相关品牌",
    },
    brands: {
      type: Array,
      default: () => [],
    },
    loading: Boolean,
  },

  setup(props) {
    const brandsTable = computed(() => {
      return chunk(props.brands, props.brands.length % 2 === 0 ? 2 : 1);
    });
    return {
      brandsTable,
    };
  },
};
</script>
<style lang="scss" scoped>

::v-deep{
  .table{
    a{
      display: block;
    }
  }
}
.brand {
  background: linear-gradient(135deg, rgba(13, 109, 237, 0.13) 4%, rgba(235, 237, 241, 0.2) 51%, rgba(182, 213, 255, 0.27) 100%);

  &-item {
    border-bottom: 1px solid #D8D8D8;
  }

  &-item:first-child, &-item:last-child {
    border-bottom: none;
    color:red;
  }
}

</style>
